import React, { PropTypes } from 'react';
import { FormattedRelative } from 'react-intl';
import { Link } from 'react-router';
import classNames from 'classnames';

import './styles.scss';


const ReviewContent = ({ title, time, body, user, children, className }) => (
  <div className={classNames('review card', className)} styleName='content'>

    <h3 className='card-title'>{ title }</h3>

    { children }

    <div className='text-muted review-meta' styleName='review-meta'>
      { user ?
        <span styleName='meta-user'>
          From <Link to={`/user/${user.username}/`}>{ user.public_name }</Link>,&nbsp;
        </span>
      : null }

      <FormattedRelative value={time}>
        { formatted => (
          <time dateTime={time}>{ formatted }</time>
        ) }
      </FormattedRelative>
    </div>

    <div
      className='body'
      styleName='body'
      dangerouslySetInnerHTML={{ __html: body }} // eslint-disable-line react/no-danger
    />

  </div>
);

ReviewContent.propTypes = {
  body: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  time: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]).isRequired,
  user: PropTypes.shape({
    username: PropTypes.string,
    public_name: PropTypes.string,
  }),
};

ReviewContent.defaultProps = {
  children: null,
  className: null,
  user: null,
};

export default ReviewContent;



// WEBPACK FOOTER //
// ./app/scripts/views/App/components/BaseReview/Review/ReviewContent.jsx